import React, { useState } from "react";
import Button from "react-bootstrap/esm/Button";
import { Form, Link, useNavigate, useLocation } from "react-router-dom";
import { PutApiMethod } from "../../core/services/apiService";
import constant from "../../core/constant";
import SearchableSelect from "../Common/SearchableSelect";

const EditAgent = () => {
    const locations = useLocation();
    let navigate = useNavigate();

    const { id, names, emails, timeZone: savedTimeZone } = locations.state || {};
    const [name, setName] = useState(names || "");
    const [email, setEmail] = useState(emails || "");
    const [timeZone, setTimeZone] = useState(savedTimeZone || "");
    const [errorResponse, setErrorResponse] = useState([]);
    const [nameError, setNameError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [emailvalid, setEmailvalid] = useState(false);
    const [timeZoneError, setTimeZoneError] = useState(false);

    if (!locations.state) {
        navigate(constant.AGENT_LIST);
        return null;
    }

    const handleSubmit = (e: any) => {
        e.preventDefault();
        let postDate = {
            name: name,
            email: email,
            timeZone: timeZone,
        };
        setNameError(false);
        setEmailvalid(false);
        setEmailError(false);
        setTimeZoneError(false);
        if (name === "") {
            setNameError(true);
            console.log("Please fill all the required fields");
        } else {
            setNameError(false);
        }
        if (!timeZone) {
            setTimeZoneError(true);
        }
        if (email === "") {
            setEmailvalid(true);
            return false;
        } else {
            let pattern = new RegExp(
                /^\w+([\+\.-]?\w+)*@\w+([\+\.-]?\w+)*(\.\w{2,3})+$/
            );
            if (!pattern.test(email)) {
                setEmailError(true);
                return false;
            }
            if (!timeZone) {
                return false;
            }
            if (name.length > 0) {
                console.log(postDate, "final");
                PutApiMethod(`tenant/agent-crud/${id}`, postDate)
                    .then((res) => {
                        console.log(res.data.status);
                        // res.data.status = "success" ? setSuccessResponse("username " + name + "added as Super Admin") : "";
                        if (res.data.status === "Success") {
                            navigate(constant.AGENT_LIST, {
                                state: { name: name, action: "edit" },
                            });
                        }
                    })
                    .catch((err) => {
                        setErrorResponse(err.response?.data?.errors || []);
                        console.log(err.response?.data, "error");
                    });
            }
        }
    };

    return (
        <>

            <div className="text-danger text-center m-3">
                {errorResponse
                    ? Object.values(errorResponse).map((err: any, i: any) => {
                        return (
                            <li key={i} className="link-text">
                                {err.msg}
                            </li>
                        );
                    })
                    : ""}
            </div>
            <div className="conatiner-fluid m-3">
                <div className="row">
                    <div className="col-md-10">
                        <h2 className="heading-font head-heading">
                            <span className="header_underline">
                                Edit Agent - {name}
                            </span>
                        </h2>
                    </div>

                    <div className="col-md-2">
                        <Link to={constant.AGENT_LIST} className="text-white link-text">
                            <Button
                                className="m-3  buttons"
                                style={{ background: "#0187c4" }}
                            >
                                <i
                                    className="bi bi-list-ul m-2"
                                    aria-hidden="true"
                                ></i>
                                List
                            </Button>
                        </Link>
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-4">
                        <label>
                            Name <span className="text-danger">*</span>
                        </label>
                    </div>
                    <div className="col-md-4">
                        <input
                            type="text"
                            name="name"
                            defaultValue={names}
                            minLength={4}
                            maxLength={40}
                            pattern="[a-zA-Z][a-zA-Z ]{0,}"
                            className="form-control"
                            onChange={(e) => setName(e.target.value)}
                        />
                        {nameError && name.length <= 0 ? (
                            <small className="text-danger">
                                Name is required
                            </small>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-4">
                        <label>
                            Email <span className="text-danger">*</span>
                        </label>
                    </div>
                    <div className="col-md-4">
                        <input
                            type="text"
                            name="email"
                            defaultValue={emails}
                            className="form-control"
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {emailError ? (
                            <small className="text-danger">
                                Please enter Email in the correct format
                            </small>
                        ) : (
                            ""
                        )}
                        {emailvalid && email.length <= 0 ? (
                            <small className="text-danger">
                                Email is required
                            </small>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-4">
                        <label>
                            Time Zone <span className="text-danger">*</span>
                        </label>
                    </div>
                    <div className="col-md-4">
                        <SearchableSelect
                            options={constant.timeZones}
                            value={timeZone}
                            onChange={(val) => setTimeZone(val)}
                            placeholder="Search timezone..."
                        />
                        {timeZoneError && !timeZone ? (
                            <small className="text-danger">
                                Time zone is required
                            </small>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
                <div className="text-center">
                    <button
                        type="submit"
                        className="btn btn-primary m-2 app-button-color"
                        onClick={handleSubmit}
                    >
                        Update
                    </button>
                    <Link to={constant.AGENT_LIST}>
                        <button type="button" className="btn btn-secondary m-2">
                            Cancel
                        </button>
                    </Link>
                </div>
            </div>
        </>
    );
};

export default EditAgent;
